/* eslint-disable */
export default {
    data: () => ({
        isResponsible: false
    }),
    methods: {
        beforeAddSocketDetails(item) { },
        afterAddSocketDetails(item) { },
        beforeDeleteSocketDetails(item) { },
        afterDeleteSocketDetails(item) { },
        beforeReloadPageModules(item) { },
    },
    sockets: {
        // EVENTOS PARA MANIPULAÇÃO DOS DETALHES
        // Evento emitido quando o usuário adiciona detalhes a algum item.
        addSocketDetailsCompanyUser(item) {
            // utilizado somente para
            if (this.beforeAddSocketDetails(item) !== false) {
                if (item.values.shift) {
                    this.editedItem[item.details].unshift(item.values.comment)
                    this.editedItemDB[item.details].unshift(item.values.comment)
                } else {
                    this.editedItem[item.details].push(item.values)
                    this.editedItemDB[item.details].push(item.values)
                    this.afterAddSocketDetails(item)
                }
            }
        },
        // Evento emitido quando o usuário edita detalhes de algum item.
        // Necessario ter os dois pois quando está aberta um atela de gerencimento e outra de companyUser, não atualiza nas duas.
        editSocketDetailsCompanyUser(item) {
            Object.assign(this.editedItem[item.details].find((val) => { return val.id === item.values.id }) || {}, item.values)
            Object.assign(this.editedItemDB[item.details].find((val) => { return val.id === item.values.id }) || {}, item.values)
        },
        // Evento emitido quando o usuário exclui detalhes de algum item.
        deleteSocketDetailsCompanyUser(item) {
            if (this.beforeDeleteSocketDetails(item) !== false) {
                const index = this.editedItem[item.details].findIndex((element) => { return element.id === item.values.id })
                this.editedItem[item.details].splice(index, 1)
                this.editedItemDB[item.details].splice(index, 1)
                this.afterDeleteSocketDetails(item)
            }
        },
        // Este evento funciona da seguinte maneira: é disparado quando o usuário é removido de uma empresa, quando uma empresa que ele participa é excluída ou quando o privilégio de administrador de uma empresa é retirado deste usuário.
        // Ele é responsável por mostrar na tela o alerta para informar o usuário em uma das duas situações:
        // 1 - Ele está gerenciando/editando a empresa da qual ele foi removido
        // 2 - A empresa que ele está gerenciando/editando foi excluída do sistema.
        deleteSocketDetailUserCompanyUser(item) {
            // Verifica se o usuário que recebeu o evento é o participante excluído (ou se ele é participante da empresa (no caso 2))
            console.log(item.company_id, this.$auth.user().company_id)
            if (item.company_id && item.company_id !== this.$auth.user().company_id) {
                return
            }
            if (item.user_id === this.$auth.user().id) {
                if (item.unlockRoom) {
                    this.$socket.emit('leaveRoom', { room: item.unlockRoom, view: this.view })
                }
                this.$store.commit('dialogWarning/change_values', { text: item.text, showDialog: true })
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/mixin/socketCompanyUserDialog.js